/**
 * Generic Mutations
 */
export const SET_PROPERTY = 'SET_PROPERTY'
export const SET_LIST_PROPERTY = 'SET_LIST_PROPERTY'
export const SET_STATE_PROPERTY = 'SET_STATE_PROPERTY'
export const SET_FILTER_PROPERTY = 'SET_FILTER_PROPERTY'
export const SET_AUTHORIZED = 'SET_AUTHORIZED'

export const APP_LOADING = 'APP_LOADING'
export const SET_SAVE_STATUS = 'SAVE_STATUS'

export const SET_LIST = 'SET_LIST'
export const SET_SINGLE = 'SET_SINGLE'
export const ADD_SINGLE = 'ADD_SINGLE'
export const ADD_LIST = 'ADD_LIST'
export const SET_PAGINATION_DATA = 'SET_PAGINATION_DATA'
export const SET_SELECTED = 'SET_SELECTED'
export const SET_MONTH = 'SET_MONTH'
export const SET_LINES = 'SET_LINES'
export const REMOVE_LINE = 'REMOVE_LINE'
export const REMOVE_LIST_ITEM = 'REMOVE_LIST_ITEM'
export const UPDATE_LIST_ITEM = 'UPDATE_LIST_ITEM'

/**
 * Specific Mutations
 */
export const SET_UTILIZATION = 'SET_UTILIZATION'
export const RESET_UTILIZATION = 'RESET_UTILIZATION'

export const SET_USERS = 'SET_USERS'
export const SET_USER = 'SET_USER'
export const SET_TIMESHEET = 'SET_TIMESHEET'
export const ADD_USERS = 'ADD_USERS'
export const SET_USERS_PAGINATION = 'SET_USERS_PAGINATION'
export const SET_TIMER = 'SET_TIMER'

export const SET_QUOTES = 'SET_QUOTES'
export const ADD_QUOTES = 'ADD_QUOTES'
export const SET_QUOTE = 'SET_QUOTE'
export const SET_QUOTES_PAGINATION = 'SET_QUOTES_PAGINATION'

export const SET_SLAS = 'SET_SLAS'
export const SET_SLA = 'SET_SLA'
export const ADD_SLA = 'ADD_SLA'
export const ADD_SCHEDULE = 'ADD_SCHEDULE'
export const RESET_SLA = 'RESET_SLA'

export const SET_STATUSES = 'SET_STATUSES'
export const ADD_STATUS = 'ADD_STATUS'
export const SET_STAGES = 'SET_STAGES'
export const SET_PROJECT = 'SET_PROJECT'
export const SET_PROJECTS = 'SET_PROJECTS'
export const SET_PROJECTS_STATUS = 'SET_PROJECTS_STATUS'

export const SET_GROUPS = 'SET_GROUPS'

export const SET_EPICS = 'SET_EPICS'
export const SET_EPIC_PROPERTY = 'SET_EPIC_PROPERTY'
export const ADD_EPIC = 'ADD_EPIC'
export const REMOVE_EPIC = 'REMOVE_EPIC'
export const SET_TAG = 'SET_TAG'

export const ADD_GROUP = 'ADD_GROUP'

export const SET_TAGS = 'SET_TAGS'
export const ADD_TAG = 'ADD_TAGS'

export const SET_GANTT_ITEM = 'SET_GANTT_ITEM'
export const SET_GANTT_ITEMS = 'SET_GANTT_ITEMS'
export const ADD_GANTT_ITEM = 'ADD_GANTT_ITEM'
export const REMOVE_GANTT_ITEM = 'REMOVE_GANTT_ITEM'
export const RESET_GANTT_ITEM = 'RESET_GANTT_ITEM'

export const SET_TIMELINE = 'SET_TIMELINE'
export const ADD_TIMELINE = 'ADD_TIMELINE'
export const SET_TIMELINE_PAGE = 'SET_TIMELINE_PAGE'
export const SET_TIMELINE_END = 'SET_TIMELINE_END'

export const SET_CONTACTS = 'SET_CONTACTS'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_CLIENT = 'SET_CLIENTS'

export const SET_USERSTORY_DOCUMENT = 'SET_USERSTORY_DOCUMENT'
export const RESET_USERSTORY_DOCUMENT = 'RESET_USERSTORY_DOCUMENT'
export const ADD_USERSTORY_DOCUMENT_VERSION = 'ADD_USERSTORY_DOCUMENT_VERSION'

export const ADD_USERSTORY = 'ADD_USERSTORY'
export const ADD_USERSTORY_AT_INDEX = 'ADD_USERSTORY_AT_INDEX'
export const REMOVE_USERSTORY = 'REMOVE_USERSTORY'
export const SET_USERSTORY_PROPERTY = 'SET_USERSTORY_PROPERTY'
export const SET_USERSTORIES = 'SET_USERSTORIES'

export const SET_COSTING = 'SET_COSTING'
export const SET_COSTING_LINES = 'SET_COSTING_LINES'
export const SET_COSTING_LINE = 'SET_COSTING_LINE'
export const ADD_COSTING_LINE = 'ADD_COSTING_LINE'
export const SET_TEMPLATES = 'SET_TEMPLATES'

export const SET_FILTERS = 'SET_FILTERS'
export const SET_FILTER = 'SET_FILTER'
export const UNSET_FILTER_USER_ID = 'UNSET_FILTER_USER_ID'
export const SET_DISPLAYED_USERSTORIES = 'SET_DISPLAYED_USERSTORIES'